import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { InitNetworkResponse, NetworkColumn } from '../helpers/types';
import { ColumnValidator } from '../helpers/columnValidator';
import { API_TYPE_COMPANY_FILTER, API_TYPE_POLICY_FILTER } from '../../../webcomponents.constants';
import { GridFiltersHelper } from '../../../grid/gridFilters/helpers/GridFiltersHelper';

export class NetworkAppContainerConsoleDataProvider extends BaseWebComponentDataProvider {
  async computeUserConfig(): Promise<InitNetworkResponse> {
    return {
      allColumns: ColumnValidator.getValidColumns(),
      predefinedFilterKeys: [NetworkColumn.NAME],
      filtersUiConfigs: [
        {
          key: NetworkColumn.TYPE,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.ENDPOINT_TYPE,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.OS_TYPE,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.MANAGEMENT_STATUS,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.SECURITY_ISSUES,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.PENDING_ACTIVITY,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.POLICY_TYPE,
          config: {
            isClearable: true,
            canSelectAll: true,
          },
        },
        {
          key: NetworkColumn.POLICY_STATUS,
          config: {
            isClearable: true,
            canSelectAll: true,
          },
        },
        {
          key: NetworkColumn.ROLE,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.COMPANY,
          config: {
            apiType: API_TYPE_COMPANY_FILTER,
            canDelete: true,
            populateFilterCallback: GridFiltersHelper.populateFilterCallback,
          },
        },
        {
          key: NetworkColumn.POLICY,
          config: {
            apiType: API_TYPE_POLICY_FILTER,
            canDelete: true,
            populateFilterCallback: GridFiltersHelper.populateFilterCallback,
          },
        },
        {
          key: NetworkColumn.AVAILABLE_POLICIES,
          config: {
            apiType: API_TYPE_POLICY_FILTER,
            canDelete: true,
            populateFilterCallback: GridFiltersHelper.populateFilterCallback,
          },
        },
        {
          key: NetworkColumn.POWER,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.MIGRATED_TO_ANOTHER_COMPANY,
          config: {
            isClearable: true,
          },
        },
        {
          key: NetworkColumn.IN_DELETED_FOLDER,
          config: {
            isClearable: true,
          },
        },
      ],
    };
  }
}
